import React, { useState } from "react";
import AuthPrimaryButton from "./AuthPrimaryButton";

interface Props {
  btnText: string;
  handleVerification?: (data: string | number) => void;
}

function OtpVerification({ btnText, handleVerification }: Props) {
  const [codeBox, setCodeBox] = useState(new Array(4).fill(""));

  const handleNext = () => {
    const isCodeValid = codeBox.every((value) => value.trim() !== "");
    if (!isCodeValid) {
      alert("Input an OTP");
      return;
    }
    if (handleVerification) {
      handleVerification(codeBox.join(""));
    }
  };

  const handleChange = (element: HTMLInputElement, index: number): void => {
    if (isNaN(Number(element.value))) return;

    setCodeBox((prevCodeBox) =>
      prevCodeBox.map((d, idx) => (idx === index ? element.value : d))
    );

    if (element.nextSibling instanceof HTMLInputElement) {
      element.nextSibling.focus();
    }
  };

  function handleDelete(e: React.KeyboardEvent<HTMLInputElement>, index: number): void {
    if (e.key === "Backspace" && e.currentTarget.previousSibling instanceof HTMLInputElement) {
      e.preventDefault();
      e.currentTarget.previousSibling.focus();
      setCodeBox((prevCodeBox) => prevCodeBox.map((data, i) => (i !== index ? data : "")));
    } else if (
      e.key === "Backspace" &&
      !e.currentTarget.previousSibling &&
      e.currentTarget.nextSibling instanceof HTMLInputElement
    ) {
      e.preventDefault();
      setCodeBox((prevCodeBox) => prevCodeBox.map((data, i) => (i !== index ? data : "")));
    }
  }

  function handlePaste(e: any) {
    const value = e.clipboardData.getData("text");
    if (isNaN(value)) return false;
    setCodeBox(value.toString().split("").slice(0, codeBox.length));
  }

  return (
    <>
      <div className="my-6 flex justify-center gap-2.5 sm:my-10 sm:gap-[19px]">
        {codeBox.map((value, i) => (
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            className="h-12 w-12 shrink-0 rounded-[12px] border border-[#E8E0EC] px-0 text-center text-[18px] text-[#334155] outline-none transition focus:border-ryd-primary focus:ring-2 focus:ring-ryd-primary/15 sm:h-[62px] sm:w-full sm:max-w-[62px] sm:rounded-[15px] sm:text-[20px]"
            key={i}
            value={value}
            maxLength={1}
            onChange={(e) => handleChange(e.target, i)}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => {
              const target = e.target as HTMLInputElement;
              if (e.keyCode === 8 || e.key === "Backspace") {
                handleDelete(e, i);
              } else if (e.key === "ArrowLeft" && target.previousSibling) {
                e.preventDefault();
                (target.previousSibling as HTMLInputElement).focus();
              } else if (e.key === "ArrowRight" && target.nextSibling) {
                e.preventDefault();
                (target.nextSibling as HTMLInputElement).focus();
              }
            }}
            onPaste={handlePaste}
          />
        ))}
      </div>
      <AuthPrimaryButton type="button" onClick={handleNext} showArrow={false}>
        {btnText}
      </AuthPrimaryButton>
    </>
  );
}

export default OtpVerification;
